import { createContext, useContext } from "react";
import { makeProvider, normalize } from "../helpers/makeContexts";

const dashpermissionInit = {
  dashboardpermissions: {},
  isLoadingDashPermissions: false,
};

function dashpermissionReducer(draft, { type, payload }) {
  switch (type) {
    case "setDashPermissions": {
      draft.dashboardpermissions = normalize(payload)
      break;
    }
    case "setIsLoadingDashPermissions": {
      draft.isLoadingDashPermissions = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [DashPermissionContext, DashPermissionDispatchContext] = [
  createContext(null),
  createContext(null),
];

export const DashPermissionProvider = makeProvider(
  DashPermissionContext, 
  DashPermissionDispatchContext, 
  dashpermissionReducer, 
  dashpermissionInit
);

export function useDashPermissionStore() {
  return useContext(DashPermissionContext);
}

export function useDashPermissionDispatch() {
  return useContext(DashPermissionDispatchContext);
}